import type { TruckFuelEconomy } from '../trucks.api';

export interface FuelEconomyLabels {
  figure: string;
  basis: string;
  trend: string | null;
}

function trendLabel({ direction, changePercent }: TruckFuelEconomy['trend']): string | null {
  if (direction === 'unknown' || changePercent === null) return null;
  if (direction === 'steady') return 'Steady against the trips before';
  const size = `${Math.abs(changePercent)}%`;
  return direction === 'rising' ? `km/l up ${size} on the trips before` : `km/l down ${size} on the trips before`;
}

/** What the card says for each way a figure can come about; a starting value is named as one so nobody reads it as measured. */
export function fuelEconomyLabels(economy: TruckFuelEconomy): FuelEconomyLabels {
  if (economy.kmPerLitre === null)
    return { figure: 'No figure yet', basis: 'Enter an expected consumption below to start from, or record fuel on trips.', trend: null };
  const figure = `${economy.kmPerLitre.toFixed(1)} km/l`;
  if (economy.source === 'rolling') return { figure, basis: `Over its last ${economy.sampleCount} trips`, trend: trendLabel(economy.trend) };
  const origin = economy.source === 'truck_initial' ? "this truck's expected consumption" : "its class's default";
  return { figure, basis: `Starting figure from ${origin}, until it has enough trips of its own`, trend: null };
}
